import { Sapling } from "@saplingai/sapling-js/observer";
import logger from "@helpers/Logger";

let isInitialized = false;

function isEnabled(): boolean {
  const v = import.meta.env.VITE_ENABLE_SAPLING;
  if (v === undefined || v === "") return true;
  return v === "true" || v === "1";
}

export function saplingIsEnabled(): boolean {
  return isEnabled();
}

export function saplingInitIfEnabled(): void {
  if (!isEnabled()) return;

  try {
    let endpointHost = `${import.meta.env.VITE_API_URL}`;
    endpointHost = endpointHost.replace(/\/api$/, "");
    if (endpointHost?.length === 0 && window.location.hostname.includes("localhost")) {
      logger.warn("Running localhost, overriding Sapling endpoint");
      endpointHost = "https://dev-api.shrpa.com";
    }
    logger.info("Initializing Sapling " + endpointHost);

    Sapling.init({
      endpointHostname: endpointHost,
      // @ts-ignore
      saplingPathPrefix: "/sapling",
    });
    isInitialized = true;
  } catch (e) {
    logger.error("Error setting up Sapling: " + e);
  }
}

export function saplingObserveIfEnabled(element: HTMLTextAreaElement | null): void {
  if (!isEnabled() || !isInitialized || !element) return;
  try {
    Sapling.observe(element);
  } catch (e) {
    logger.error("Error observing Sapling element: " + e);
  }
}

export function saplingUnobserveIfEnabled(element: HTMLTextAreaElement | null): void {
  if (!isEnabled() || !isInitialized || !element) return;
  try {
    Sapling.unobserve(element);
  } catch (e) {
    logger.error("Error unobserving Sapling element: " + e);
  }
}
